import React from 'react'
import Categories from '../components/Categories'
import Copyright from '../components/Copyright'
import Footer from '../components/Footer'
import Header from '../components/Header'
import Latest from '../components/Latest'
import TopSelling from '../components/TopSelling'
import Tablets from '../components/Tablets'
import Accessories from '../components/Accessories'
import MidAlert from '../components/MidAlert'

const Homepage = () => {
  return (
    <div className='App bg-gray-100 font-sans'>
      <div>
        <Header />
        <div className='mx-2 md:mx-5 lg:mx-24 xl:mx-38 xxl:mx-44'>
          <div className='ml-2'>
            <div className='mt-10'>
              <Categories />
              <Latest />
              <TopSelling />
            </div>{' '}
          </div>
        </div>
        <div>
          <MidAlert />
        </div>
        <div className='mx-2 md:mx-5 lg:mx-24 xl:mx-38 xxl:mx-44'>
          <Tablets />
          <Accessories />
        </div>
      </div>
      <Footer />
      <Copyright />
    </div>
  )
}

export default Homepage
